import { 
	loadingPage,
	loginPage,
	legalPage,
	dashboardPage,
	connectStorePage,
    registerPage
} from "./pages.js";

export const router = function (response) {
	
	if(response==null) {
		return loadingPage;
	}
	
	var responseJSON = JSON.parse(response);
	
	if (responseJSON==null) {
		return "<b>" + "ERROR" + "</b>";
	}
	
	var view = responseJSON.view;
	var data = responseJSON.data;
	
	switch(view) {
        case "oauth":
            window.parent.location.href = data.redirect_url;
            return loadingPage;
		case "login":			
			//return connectStorePage(data);
			return loginPage;
		case "dashboard":
			return dashboardPage(data);
		case "legal":
			return legalPage;
        case "register":
            return registerPage;
        default:
			return loadingPage;			
	}
}
